<template>
  <div id="prelive-section" class="prelive-section" v-if="getOpenSportId">


    <!-- ── Header ──────────────────────────────────────────── -->
    <div class="tournament-card-header">
      <div class="nav-left" v-if="activeSport && getMixedPreview" @click="closePanel">
        <button class="close-icon-btn" >
          <svg data-v-73c61f56="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="bi bi-arrow-left"><path data-v-73c61f56="" fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"></path></svg>
        </button>
        <div class="breadcrumbs" >
          <span class="crumb crumb--clickable" @click="closePanel">
            {{activeSport.name }}
          </span>
        </div>
      </div>

      <div class="nav-left" v-else @click="goHome">
        <button class="close-icon-btn" >
          <svg data-v-73c61f56="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="bi bi-arrow-left"><path data-v-73c61f56="" fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"></path></svg>
        </button>
        <div class="breadcrumbs">
          <span class="crumb crumb--clickable" >
            {{$t('home')}}
          </span>
        </div>
      </div>


    </div>

    <div class="text-page-title" v-if="activeSport">
      <span class="">{{ activeSport.name }}</span>
    </div>

    <smart-toolbar-american
        class=""
        :groups="filteredItemWidget"
        :group-selected="itemActive"
        :tabs-scrollable="false"
        :show-expand-collapse="false"
        :show-search="false"
        :small-label="true"
        @update:groupSelected="onSelectGroup"
    />


    <!-- ── Torneo selezionato (mixed preview) ───────────────── -->
    <v-progress-linear indeterminate color="var(--color-primary)" v-if="getMixedPreviewLoading" />
    <MixedTournamentPreview v-if="getMixedPreview" />

    <FeaturedTournamentsAmerican v-if="itemActive === 'featured_tournaments' && !getMixedPreview"/>

    <!-- ── Categories / Tournaments list ───────────────────── -->
    <div class="ps-list" v-if="itemActive === 'competitions' && !getMixedPreview">
      <div
        v-for="cat in getActiveSportCategories"
        :key="cat.categoryId"
        class="ps-cat"
        :id="`category-${cat.categoryId}`"
      >
        <!-- Category row -->
        <div class="ps-cat-row" @click="onToggleCategory(cat.categoryId, getOpenSportId)">
          <img
            class="ps-cat-icon"
            :src="`${categoryPath}${cat.categoryId}.svg`"
            :alt="cat.name"
            @error="e => e.target.style.display = 'none'"
          />
          <span class="ps-cat-name">{{ cat.name }} <span>({{cat.count}})</span></span>
          <span v-if="cat.live && getSettings.enableLive" class="ps-live-badge">{{ $t('live') }}</span>
          <v-icon
            class="ps-chevron"
            :class="{ 'is-open': getExpandedCatIds.includes(cat.categoryId) }"
            size="16"
          >mdi-chevron-down</v-icon>
        </div>

        <!-- Tournament list -->
        <transition name="tmt-expand">
          <div v-if="getExpandedCatIds.includes(cat.categoryId)" class="ps-tmt-list">

            <div v-if="getLoadingCatIds.includes(cat.categoryId)" class="ps-tmt-loading">
              <v-progress-circular indeterminate size="14" width="2" color="var(--color-primary)" />
            </div>

            <template v-else>
              <div
                v-for="tmt in (getTournamentsByCat[cat.categoryId] || [])"
                :key="tmt.tournamentId"
                class="ps-tmt-row"
                @click="onSelectTournament(getOpenSportId, cat.categoryId, tmt)"
              >
                <img
                    :src="`${tournamentPath}${tmt.tournamentId}.webp`"
                    :alt="tmt.name"
                    class="thumb-img"
                    @error="onFavImageError"
                />
                <span class="ps-tmt-name">{{ tmt.name }}</span>
                <span v-if="tmt.live && getSettings.enableLive" class="ps-live-badge">{{ $t('live') }}</span>

              </div>

              <div v-if="!(getTournamentsByCat[cat.categoryId] || []).length" class="ps-tmt-empty">
                —
              </div>
            </template>

          </div>
        </transition>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import { isMarketPlayable, resolveEventMarket } from '@/utils/marketLineUtils';
import { isMobileOnly, isTablet } from "mobile-device-detect";
import LogoCompetitors from "@/components/center_widgets/LogoCompetitors.vue";
import QuickSelectEventLive from "@/components/center_widgets/Live/QuickSelectEventLive.vue";
import SmartToolbarAmerican from "@/components/american/SmartToolbarAmerican.vue";
import GeneralSpreadSelectorV3 from "@/components/center_widgets/Previews/spreadSelectors/GeneralSpreadSelectorV3.vue";
import MixedTournamentPreview from "@/components/center_widgets/Previews/MixedTournamentPreview.vue";

import FeaturedTournamentsAmerican from '@/components/american/FeaturedTournamentsAmerican.vue';
import { MARKET_NOT_NAME_IN_OUTCOME } from '../../constants/marketConstants';



export default {
  name: 'PreliveSectionAmerican',
  components: {SmartToolbarAmerican, QuickSelectEventLive, LogoCompetitors, GeneralSpreadSelectorV3, MixedTournamentPreview, FeaturedTournamentsAmerican },
  filters: {
    formatDecimal(value) {
      if (value === undefined || value === null) return '';
      const strVal = String(value).trim();
      if (strVal.includes('/') || strVal.startsWith('+') || strVal.startsWith('-')) return strVal;
      const num = parseFloat(strVal);
      if (isNaN(num)) return strVal;
      return num.toFixed(2);
    }
  },
  data: () => ({
    homeItemWidget: [{_id:'featured_tournaments', active: true}, {_id:'competitions', active: true}],
    itemActive: 'competitions',
    featuredTournaments: [],
    foundFavourites: [],
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons-color/',
    isSmallScreen: false,
    categoryPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/categories/round_flags/',
    tournamentPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/tournaments/',
    light: (window.icons === 'light'),
    maxMarkets: 3,
    infoColWidth: '350px',
    customLines: {},
    playerShowMore: {},
    compactStates: {},
    scorePickers: {},
    marketPickerOpen: {},      // { [tournamentId]: bool }
    marketSearchQuery: {},     // { [tournamentId]: string }
    playerMenuOpen: {},          // { [eventId_marketId_side]: bool }
    playerSpecifierSearch: {},   // { [eventId_marketId_side]: string }
    playerSelectedSpecifier: {}, // { [eventId_marketId_side]: specifier }
    previewPlayerTeam: {},       // { [eventId_marketId]: 'h' | 'a' } — mobile team toggle
    // MAPPA CACHE per ottimizzare O(1) il controllo sui mercati player senza cicli for annidati in template
    playerMarketCache: new Map(),
    isDragging: false,
    hasDragged: false,
    startX: 0,
    scrollLeft: 0,
    activeTooltipId: null,
    activeMobileTooltipId: null,
    tooltipContent: '',
    tooltipStyle: {},
    tooltipPlacement: 'above',

  }),
  computed: {
    ...mapGetters({
      'getPreview': 'previewPrematch/getPreview',
      'getLoadingPreviewIds': 'previewPrematch/getLoadingPreview',
      'isGlobalLoading': 'previewPrematch/isLoading',
      'getConfiguredGroupsMarkets': 'previewPrematch/getConfiguredGroupsMarkets',
      'getMarketsGroupsIdActive': 'previewPrematch/getMarketsGroupsIdActive',
      'getPreviewTabsSelectedForTournament': 'previewPrematch/getPreviewTabsSelectedForTournament',
      'getOddsSources': 'cart/getOddsSources',
      'getLanguage': 'settings/getLanguage',
      'getPlatformId': 'settings/getPlatformId',
      'isLoadingMore': 'previewPrematch/isLoadingMore',
      'getPaginationBySource': 'previewPrematch/getPaginationBySource',
      'getMarketConfig': 'settings/getMarketConfig',
      'getOpenSportId':           'topsports/getOpenSportId',
      'getSortedSports':          'topsports/getSortedSports',
      'getActiveSportCategories': 'topsports/getActiveSportCategories',
      'getTournamentsByCat':      'topsports/getTournamentsByCat',
      'getExpandedCatIds':        'topsports/getExpandedCatIds',
      'getTabBySport':            'topsports/getTabBySport',
      'getLoadingCatIds':         'topsports/getLoadingCatIds',
      'getMixedPreview':          'topsports/getMixedPreview',
      'getMixedPreviewLoading':   'topsports/getMixedPreviewLoading',
      'getPreviousPage':          'sportNavigation/getPreviousPage',
      'apiUrl':                   'settings/getUrlApi',
      'token':                    'settings/getToken',
      'getFeaturedTournamentsStore': 'featuredEvents/getFeaturedTournaments',
      'getSettings':              'cart/getSettings',
      'getCompetitorsInOutcome':  'settings/getCompetitorsInOutcome',
    }),
    hasFeaturedTournamentsForSport() {
      const list = this.getFeaturedTournamentsStore.length
        ? this.getFeaturedTournamentsStore
        : this.featuredTournaments;
      if (!this.getOpenSportId || !list.length) return false;
      return list.some(t => String(t.sportId) === String(this.getOpenSportId));
    },
    filteredItemWidget() {
      return this.homeItemWidget
          .filter(item => item.active)
          .filter(item => item._id !== 'featured_tournaments' || this.hasFeaturedTournamentsForSport)
          .map(item => ({ name: this.$t(item._id), _id: item._id }));
    },
    activeSport() {
      if (!this.getOpenSportId) return null;
      return this.getSortedSports.find(s => String(s.id) === String(this.getOpenSportId)) ?? null;
    },
    favouritesSet() {
      const set = new Set();
      this.foundFavourites.forEach(fav => set.add(String(fav.id)));
      return set;
    },
  },
  watch: {
    getOpenSportId: {
      immediate: true,
      async handler(newId) {
        if (!newId) return;

        // Reset navigation history whenever a (new) sport panel is opened
        this.clearNavHistory();

        // Restore saved tab for this sport from the store, validating it is available
        const savedTab = this.getTabBySport[String(newId)] || null;
        const savedIsValid = savedTab === 'competitions' ||
          (savedTab === 'featured_tournaments' && this.hasFeaturedTournamentsForSport);
        if (savedIsValid) {
          this.itemActive = savedTab;
        } else {
          this.itemActive = this.hasFeaturedTournamentsForSport ? 'featured_tournaments' : 'competitions';
        }

        this.clearMixedPreview();

        // Re-fetch tournaments for categories that were expanded but whose data was cleared
        for (const catId of this.getExpandedCatIds) {
          if (!this.getTournamentsByCat[catId] || !this.getTournamentsByCat[catId].length) {
            await this.fetchTournaments({ categoryId: catId, sportId: newId });
          }
        }

        // Auto-expand first 3 categories
        await this.autoExpandFirstCategories(newId);
      },
    },
    getActiveSportCategories(newCats) {
      if (newCats && newCats.length > 0 && this.getOpenSportId) {
        this.autoExpandFirstCategories(this.getOpenSportId);
      }
    },
    itemActive(val) {
      if (!this.getOpenSportId) return;
      this.setTabForSport({ sportId: this.getOpenSportId, tab: val });
    },
    getTabBySport: {
      deep: true,
      handler(newTabs) {
        if (!this.getOpenSportId) return;
        const tab = newTabs[String(this.getOpenSportId)];
        // Shared store: sportNavigation.goBack can push 'liveandnext' from other variants,
        // but this component doesn't render it. Coerce to a supported tab.
        const resolved = tab === 'liveandnext'
            ? (this.hasFeaturedTournamentsForSport ? 'featured_tournaments' : 'competitions')
            : tab;
        if (resolved && resolved !== this.itemActive) {
          this.itemActive = resolved;
        }
      },
    },
  },
  methods: {
    ...mapActions({
      'closeTopsportsPanel':  'topsports/closePanel',
      'toggleCategory':       'topsports/toggleCategory',
      'fetchTournaments':     'topsports/fetchTournaments',
      'setTabForSport':       'topsports/setTabForSport',
      'fetchMixedPreview':    'topsports/fetchMixedPreview',
      'clearMixedPreview':    'topsports/clearMixedPreview',
      'pushNavHistory':       'sportNavigation/pushHistory',
      'popNavHistory':        'sportNavigation/popHistory',
      'clearNavHistory':      'sportNavigation/clearHistory',
      'removeFromPreview':    'previewPrematch/removeFromPreview',
      'fetchSettingsGroupsMarketV3': 'previewPrematch/fetchSettingsGroupsMarketV3',
      'fetchPreviewForMarketV3': 'previewPrematch/fetchPreviewForMarketV3',
      'addOrUpdateIndexOfTabActiveForThisTournament': 'previewPrematch/addOrUpdateIndexOfTabActiveForThisTournament',
      'fetchEventDetailV3':   'detailPrematch/fetchEventDetailV3',
      'setLoadingPreview':    'odds/setLoadingPreview',
      'addOddToCartV3':       'cart/addOddToCartV3',
      'fetchPreviewV3':       'previewPrematch/fetchPreviewV3',
      'goBack':               'sportNavigation/goBack',
      'ensureCategoryExpanded': 'topsports/ensureCategoryExpanded',
      'resetPreviewLive': 'previewLive/resetPreviewLive',
      'setActiveTournamentIdLivePreview': 'marketview/setActiveTournamentIdLivePreview',
      'setViewMode': 'ui/setViewMode',
      'setSubaction': 'ui/setSubaction'
    }),
    async autoExpandFirstCategories(sportId) {
      const first3 = this.getActiveSportCategories.slice(0, 3);
      for (const cat of first3) {
        await this.ensureCategoryExpanded({ sportId, categoryId: cat.categoryId });
      }
    },
    onSelectGroup(id) {
      if (id !== this.itemActive) {
        this.pushNavHistory();
        this.itemActive = id;
      }
    },
    // ── Topsports panel handlers ────────────────────────────
    closePanel() {

      this.goBack()
      // const prev = this.getPreviousPage;
      // const prelivePages = ['prelive_live', 'prelive_competitions', 'prelive_tournament'];
      // if (prev && prelivePages.includes(prev.page)) {
      //   // Navigate back within the prelive panel instead of closing it
      //   this.popNavHistory();
      //   if (prev.page === 'prelive_competitions') {
      //     this.clearMixedPreview();
      //     this.itemActive = 'competitions';
      //   } else if (prev.page === 'prelive_live') {
      //     this.clearMixedPreview();
      //     this.itemActive = 'liveandnext';
      //   }
      // } else {
      //   this.closeTopsportsPanel();
      // }
    },
    goHome() {
      const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean);
      detailSources.forEach(source => this.removeFromDetail({ source }));

      const previewSources = [...(this.getTournamentsActive || [])];
      previewSources.forEach(source => this.removeFromPreview({ source }));

      const liveSources = [...(this.getEventsLiveDetailActive || [])];
      liveSources.forEach(source => this.removeEventLiveDetail(source));

      this.closeTopsportsPanel();
      // Live-scoped: left set, it kept the prematch home filtered by the live
      // tree's tournament, and kept filtering after a sport change too.
      this.setActiveTournamentIdLivePreview([]);
      this.resetPreviewLive();
      this.setViewMode({ mode: 'preview' });
      this.setSubaction('home');
      window.parent.postMessage({ type: 'removeSlugs' }, '*');
      window.scrollTo({ top: 0, behavior: 'smooth' });

      if (this.drawer) this.menuHandler();
    },
    onSportCrumbClick() {
      this.clearNavHistory();
      this.clearMixedPreview();
      // The American variant only supports 'featured_tournaments' and 'competitions' tabs —
      // 'liveandnext' does not exist here (see homeItemWidget), so mirror the sport-open
      // watcher's fallback logic instead of pointing itemActive at a non-existent tab.
      this.itemActive = this.hasFeaturedTournamentsForSport ? 'featured_tournaments' : 'competitions';
    },
    onToggleCategory(categoryId, sportId) {
      this.toggleCategory({ categoryId, sportId });
    },
    async onSelectTournament(sportId, categoryId, tournament) {
      this.pushNavHistory();
      await this.setLoadingPreview({ status: true });

      // Rimuovi i preview esistenti così il nuovo torneo è l'unico mostrato al centro
      for (const p of (this.getPreview || [])) {
        if (p.source) await this.removeFromPreview({ source: p.source });
      }

      if (this.isMobileOnly || this.isTablet) {
        this.$root.$emit('close_sidebar_left', true);
      }

      await this.fetchPreviewV3({
        source: tournament.tournamentId + '#prematch',
        tournament: tournament.tournamentId,
        sportId,
        categoryId,
        type: 'previewOdds',
        mobilePlatform: this.isMobileOnly || this.isTablet,
        forceCallApi: true,
        groupOddsWithSpreads: true,
      });

      this.closeTopsportsPanel();
      await this.setLoadingPreview({ status: false });
      this.$nextTick(() => window.scrollTo({ top: 0 }));
    },
    // ── Other ───────────────────────────────────────────────
    onFavImageError(e) {
      e.target.style.display = 'none';
    },
    positionTooltip(rect) {
      this.$nextTick(() => {
        const tooltipEl = this.$el.querySelector('.custom-tooltip');
        if (!tooltipEl) return;
        const tipW = tooltipEl.offsetWidth;
        const tipH = tooltipEl.offsetHeight;
        const vw = window.innerWidth;
        const gap = 8;
        let top, transformY;
        if (rect.top - tipH - gap >= 0) {
          top = rect.top - gap;
          transformY = '-100%';
          this.tooltipPlacement = 'above';
        } else {
          top = rect.bottom + gap;
          transformY = '0%';
          this.tooltipPlacement = 'below';
        }
        const rawLeft = rect.left + rect.width / 2;
        let left, transformX;
        if (rawLeft - tipW / 2 < gap) {
          left = gap;
          transformX = '0%';
        } else if (rawLeft + tipW / 2 > vw - gap) {
          left = vw - gap - tipW;
          transformX = '0%';
        } else {
          left = rawLeft;
          transformX = '-50%';
        }
        this.tooltipStyle = {
          top: top + 'px',
          left: left + 'px',
          transform: `translateX(${transformX}) translateY(${transformY})`,
          opacity: '1',
        };
      });
    },
    showTooltip(nativeEvent, eventId, content) {
      const rect = nativeEvent.currentTarget.getBoundingClientRect();
      this.tooltipContent = content;
      this.tooltipStyle = { top: '-9999px', left: '-9999px' };
      this.activeTooltipId = eventId;
      this.positionTooltip(rect);
    },
    hideTooltip() {
      this.activeTooltipId = null;
      this.tooltipStyle = { ...this.tooltipStyle, opacity: '0' };
    },
    getOutcomeName(c, o, unique_id) {

      if (MARKET_NOT_NAME_IN_OUTCOME.includes(unique_id)) {
        return o.outcome_alias || o.outcome_name;
      }

      const outcome = o.outcome_name?.toLowerCase();

      if (o.outcome_name === 'X') {
        return o.outcome_alias || o.outcome_name
      }

      if (this.getCompetitorsInOutcome) {
        if (outcome === 'local') {
          return c?.[0]?.name || o.outcome_name;
        }

        if (outcome === 'visitante') {
          return c?.[1]?.name || o.outcome_name;
        }

        if ((o.outcome_name === "1" || o.outcome_name === "2") && unique_id != "128") {
          for (let i = 0; i < c.length; i++) {
            if (c[i].position === o.outcome_name ) {
              return c[i].name;
            }
          }
        }
      }

      return o.outcome_alias || o.outcome_name;
    },

    getSpecifierType(specifier) {
      if (specifier == null || String(specifier) === '') return 'neutral';
      const str = String(specifier).trim();
      if (str.startsWith('-')) return 'negative';
      if (str.startsWith('+')) return 'positive';
      return 'neutral';
    },

    isValidOdd(odd) { return odd && parseFloat(odd.outcome_odd_value) > 1 && odd.active; },

    _upsertMarketGroupActive(tournamentId, payload) {
      const mutation = this.getMarketsGroupsIdActive.findIndex(mg => mg.tournamentId == tournamentId) === -1
        ? 'previewPrematch/addMarketsGroupIdActive'
        : 'previewPrematch/replaceMarketGroupIdActive';
      this.$store.commit(mutation, payload);
    },

    isFavourite(tournamentId) {
      return this.favouritesSet.has(String(tournamentId));
    },
    toggleFavourite(tmt, cat) {
      const id = tmt.tournamentId;
      let savedFavourites = JSON.parse(localStorage.getItem('favourites')) || [];
      let removedFavourites = JSON.parse(localStorage.getItem('removed_favourites')) || [];

      if (this.isFavourite(id)) {
        this.foundFavourites = this.foundFavourites.filter(f => String(f.id) !== String(id));
        savedFavourites = savedFavourites.filter(sid => String(sid) !== String(id));
        if (!removedFavourites.includes(id)) removedFavourites.push(id);
      } else {
        this.foundFavourites.push({
          id,
          tournamentId: id,
          name: tmt.name,
          sportId: this.getOpenSportId,
          sportName: this.activeSport?.name || '',
          categoryId: cat.categoryId,
          categoryName: cat.name,
        });
        if (!savedFavourites.includes(id)) savedFavourites.push(id);
        removedFavourites = removedFavourites.filter(rid => String(rid) !== String(id));
      }

      localStorage.setItem('favourites', JSON.stringify(savedFavourites));
      localStorage.setItem('removed_favourites', JSON.stringify(removedFavourites));
      this.saveFavouritesToCookie();
    },
    saveFavouritesToCookie() {
      const data = this.foundFavourites.map(({ id, tournamentId, name, sportId, sportName, categoryId, categoryName }) => ({
        id, tournamentId, name, sportId, sportName, categoryId, categoryName,
      }));
      const expires = new Date(Date.now() + 365 * 864e5).toUTCString();
      try {
        document.cookie = `fav_tournaments=${encodeURIComponent(JSON.stringify(data))}; expires=${expires}; path=/; SameSite=Lax`;
        this.$root.$emit('favourites-updated');
      } catch {
        // fail silently
      }
    },
    restoreFavouritesFromCookie() {
      const match = document.cookie.match(/(?:^|; )fav_tournaments=([^;]*)/);
      if (!match) return;
      try {
        const restored = JSON.parse(decodeURIComponent(match[1]));
        if (Array.isArray(restored) && restored.length > 0) {
          this.foundFavourites = restored;
        }
      } catch {
        // corrupt cookie — ignore
      }
    },

    async loadFeaturedTournaments() {
      if (!this.getPlatformId) return;
      try {
        const res = await axios.get(
          `${this.apiUrl}/v3/tournaments/featured/${this.getPlatformId}?language=${this.getLanguage}&hasEvents=true`,
          { headers: { Authorization: `Bearer ${this.token}` } }
        );
        this.featuredTournaments = res.data?.data ?? [];
      } catch {
        // fail silently
      }
    },
    onResize() {
      const w = window.innerWidth;
      this.isSmallScreen = w <= 600;
      if (w > 1350) { this.maxMarkets = 3; this.infoColWidth = '350px'; }
      else if (w > 1000) { this.maxMarkets = 2; this.infoColWidth = '300px'; }
      else if (w > 600) { this.maxMarkets = 1; this.infoColWidth = '250px'; }
      else { this.maxMarkets = 1; this.infoColWidth = '110px'; }
    },

    async putCart(oddMarket, odd, event, object) {
      if (this.isValidOdd(odd)) {
        odd.type = 'prematch';
        // Salvaguarda il provider
        odd.provider = event.provider || "lsport";
        if (navigator.vibrate) {
          navigator.vibrate(20)
        }
        await this.addOddToCartV3({ oddMarket, odd, event, sport: object.sport, category: object.category, tournament: object.tournament });
        this.$root.$emit('forceUpdateSingleMultiple');
      }
    },

    async getSettingsGroup() {
      if (this.getPreview && this.getPreview.length > 0) {
        for (let i = 0; i < this.getPreview.length; i++) {
          await this.fetchSettingsGroupsMarketV3({
            'sport': this.getPreview[i].sport.id, "product_id": 0, 'lang': this.getLanguage,
            'type': "prematch", 'platform': this.getPlatformId, 'sportId': this.getPreview[i].sport.id,
            'categoryId': this.getPreview[i].category.id, 'tournamentId': this.getPreview[i].tournament.id
          });
          this.selectFirstGroupMarket(this.getPreview[i]);
        }
      }
    },


    selectFirstGroupMarket(object) {
      const tId = object.tournament.id;
      // Solo inizializzazione: non sovrascrivere una selezione già esistente
      if (this.getMarketsGroupsIdActive.findIndex(m => m.tournamentId == tId) === -1) {
        this._upsertMarketGroupActive(tId, { tournamentId: tId, groupIdSelected: 'main', groupNameSelected: 'Main' });
      }
    }
  },
  async mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
    this.restoreFavouritesFromCookie();
    await this.loadFeaturedTournaments();
    this.$root.$on('favourites-updated', this.restoreFavouritesFromCookie);
    await this.getSettingsGroup();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    this.$root.$off('favourites-updated', this.restoreFavouritesFromCookie);
  }
};
</script>

<style scoped>
/* ── Header — identico a tournament-card-header di MarketViewV3 ─────────────── */
.tournament-card-header { display: flex; align-items: center; padding: 0 !important; color: #fff; font-weight: bold; height: 40px; border: none !important; background: transparent !important; }
.tournament-card-header span { display: inline-flex !important; align-items: center; font-size: var(--font-size-3xl); line-height: 1; }
.tournament-card-header img { height: 16px; width: auto; margin-right: 6px; display: block; }
.tournament-card-header .v-icon { font-size: var(--font-size-7xl) !important; margin: 0 8px 0 0; color: #888; display: flex; }
.nav-left { display: flex; align-items: center; gap: 6px; overflow: hidden; cursor: pointer; }
.breadcrumbs { display: flex; align-items: center; font-size: var(--font-size-2xl); overflow: hidden; white-space: nowrap; gap: 20px; cursor: pointer; }
.crumb { color: var(--text-op-50-platform); font-weight: 500;text-transform: capitalize; cursor: pointer; }
.crumb--clickable { cursor: pointer; }
.nav-left:hover .crumb--clickable { color: var(--text-platform); }
.nav-left:hover .close-icon-btn { color: var(--text-platform); }
.crumb.highlight { color: var(--text-platform); font-weight: 700; }
.close-icon-btn { background: none; border: none; cursor: pointer; padding: 5px 5px 5px 0; display: flex; align-items: center; justify-content: center; }

/* ── PreliveSection layout ──────────────────────────────────────────────────── */
.prelive-section { width: 100%; display: flex; flex-direction: column; }
.ps-list {  overflow-y: auto; flex: 1; scrollbar-width: thin; scrollbar-color: var(--border-color) transparent;  display: flex; flex-direction: column; }
.ps-list::-webkit-scrollbar { width: 4px; }
.ps-list::-webkit-scrollbar-thumb { background: var(--border-color); border-radius: 4px; }

/* STILI LAYOUT */
.ps-cat-row{
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 1px solid var(--hsla-1);
  background: var(--event-background);
  transition: background 0.12s;
}
.ps-cat-row:hover .ps-cat-name, .ps-cat-row:hover .ps-chevron {
  color: var(--color-accent)!important;
}

.ps-cat-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 50%;
}

.ps-cat-name {
  flex: 1;
  font-size: var(--font-size-6xl);
  font-weight: 700;
  color: var(--text-platform);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ps-cat-name span{
  color: var(--text-op-50-platform)!important;
  font-weight: 400;
  font-size: var(--font-size-3xl);
}
.ps-chevron {
  color: var(--text-op-50-platform) !important;
  transition: transform 0.25s cubic-bezier(0.25, 0.8, 0.5, 1);
  flex-shrink: 0;
  font-size: var(--font-size-8xl) !important;
}
.ps-chevron.is-open { transform: rotate(180deg); }

/* Live badge */
.ps-live-badge {
  font-size: var(--font-size-md);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #fff;
  background: #ef4444;
  border-radius: 3px;
  padding: 1px 5px;
  flex-shrink: 0;
  line-height: 1.4;
}
.ps-live-badge--sm {
  font-size: var(--font-size-xs);
  padding: 1px 4px;
}

/* Tournament list */
.ps-tmt-list {
  border-bottom: 1px solid var(--border-color);
  display: grid;
  grid-template-columns: repeat(2,minmax(0,1fr))

}

.ps-tmt-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 8px 8px 32px;
  cursor: pointer;
  border-bottom: 1px solid var(--border-color);
  transition: background 0.12s;
  height: 44px;
}
.ps-tmt-row:last-child { border-bottom: none; }
.ps-tmt-row:hover { background: var(--bg-card); }

.ps-tmt-name {
  flex: 1;
  font-size: var(--font-size-3xl);
  line-height: 20px;
  color: var(--text-platform);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ps-tmt-loading {
  display: flex;
  justify-content: center;
  padding: 10px;
}

.ps-tmt-empty {
  padding: 8px 28px;
  font-size: var(--font-size-2xl);
  color: var(--text-op-50-platform);
}

/* Animations */
.tmt-expand-enter-active, .tmt-expand-leave-active {
  transition: max-height 0.25s cubic-bezier(0.25, 0.8, 0.5, 1), opacity 0.2s ease;
  overflow: hidden;
  max-height: 600px;
}
.tmt-expand-enter, .tmt-expand-leave-to {
  max-height: 0;
  opacity: 0;
}

/* ── Favourite star ─────────────────────────────────────────────────────────── */
.ps-fav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 3px;
  flex-shrink: 0;
  transition: background 0.12s;
}
.ps-fav-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}
.ps-star-icon {
  fill: rgba(255, 255, 255, 0.18);
  transition: fill 0.14s;
  flex-shrink: 0;
}
.ps-star-icon--active {
  fill: #fed430;
  filter: drop-shadow(0 0 3px rgba(254, 212, 48, 0.45));
}

.thumb-img{
  height: 22px;
  width: 22px;
}

.text-page-title{
  color: var(--text-platform);
  font-size: var(--font-size-8xl);
  font-weight: 700;
  padding: 1.75rem 0 0.75rem 0;
}

@media (max-width: 600px) {
  .ps-tmt-list {
    grid-template-columns: repeat(1,minmax(0,1fr))

  }

}
</style>

